<template>
	<v-container class="content" fluid>
		<v-layout row>
			<v-flex grow>
				<h1 class="display-1 px-3">Material</h1>
			</v-flex>
		</v-layout>
		<div style="height: 7px">
			<v-progress-linear
				v-if="dataLoading"
				style="margin: 0px"
				color="accent"
				indeterminate
			></v-progress-linear>
		</div>
		<v-tabs v-model="tab">
			<v-tab v-for="(werkstoff, index) in werkstoffe" :key="index">
				{{ werkstoff.werkstoffName }}
			</v-tab>
			<v-tab-item v-for="(werkstoff, index) in werkstoffe" :key="index">
				<v-data-table
					style="table-layout: fixed"
					:headers="materialHeaders"
					:items="werkstoff.materials"
					hide-actions
					class="elevation-1"
				>
					<template slot="items" slot-scope="props">
						<material-entry
							:item="props.item"
							:showDeliveryTimes="canDefineTimesToOrderMaterial"
							@update="updateMaterial($event)"
						>
						</material-entry>
					</template>
				</v-data-table>
			</v-tab-item>
		</v-tabs>
		<v-snackbar
			v-model="snackbar"
			:timeout="3000"
			:top="true"
			color="accent"
			class="black--text"
		>
			{{ snackbarText }}
			<v-btn class="blexon-button" small icon @click="snackbar = false">
				<v-icon>close</v-icon>
			</v-btn>
		</v-snackbar>
	</v-container>
</template>

<script>
import httpClient from "../store/httpClient";
import MaterialEntry from "./materialEntry.vue";

export default {
	components: {
		"material-entry": MaterialEntry,
	},
	data() {
		return {
			tab: 0,
			materialHeaders: [
				{
					text: "Liefer- bar",
					align: "left",
					sortable: false,
					value: "verfügbar",
					width: "5px",
				},
				{
					text: "Blexon Bezeichnung und Preis [pro Kilo]",
					align: "left",
					sortable: false,
					value: "blexonBeschreibung",
					width: "20%",
				},
				{
					text: "Dicke [mm]",
					align: "rigth",
					sortable: true,
					value: "thickness",
					width: "5%",
				},
				{
					text: "Rohmaterialbezeichnung Boost/Fab Fertigungsdokument",
					align: "rigth",
					sortable: false,
					value: "fertigerName",
					width: "20%",
				},
				{
					text: "Lieferzeit [Tage]",
					align: "left",
					sortable: false,
					value: "beschaffungszeit",
					width: "10px",
				},
				{
					text: "Kleinster Durchmesser [mm]",
					align: "left",
					sortable: false,
					value: "kleinsterLochdurchmesser",
					width: "10px",
				},
				{
					text: "Maximale Teilelänge/ -Breite [mm]",
					align: "left",
					sortable: false,
					value: "maximaleTeileLaenge",
					width: "10px",
				},
				{
					text: "Schweißen",
					align: "left",
					sortable: false,
					value: "welding",
					width: "10px",
				},
				{
					text: "Verzinken",
					align: "left",
					sortable: false,
					value: "zincCoating",
					width: "10px",
				},
				{
					text: "Zertifikat",
					align: "left",
					sortable: false,
					value: "certificate",
					width: "10px",
				},
			],
			werkstoffe: [],
			dataLoading: false,
			snackbar: false,
			snackbarText: "",
		};
	},
	created() {
		this.loadMaterials();
	},
	computed: {
		fertiger() {
			var fertigerId = this.$route.params.fertigerId;
			var currentFertiger = this.$store.state.fertiger.filter((f) => f.id == fertigerId);
			return currentFertiger[0];
		},
		canDefineTimesToOrderMaterial() {
			return this.$store.getters.currentFertiger(this.$route.params.fertigerId)
				.canDefineTimesToOrderMaterial;
		},
	},

	methods: {
		async loadMaterials() {
			try {
				this.dataLoading = true;
				let response = await httpClient().get(
					`api/Material/GetMaterials?fertigerId=${this.fertiger.id}`
				);
				this.werkstoffe = response.data;
			} catch (err) {
				console.log(err);
			} finally {
				this.dataLoading = false;
			}
		},
		async updateMaterial(material) {
			try {
				this.dataLoading = true;
				await httpClient().post(`api/Material/UpdateMaterial`, material);
				this.snackbarText = "Änderung erfolgreich gespeichert.";
				this.snackbar = true;
			} catch (err) {
				console.log(err);
			} finally {
				this.dataLoading = false;
			}
		},
		async copyMaterial(material) {
			material.fertigerName = material.blexonName;
			material.fertigerBeschreibung = material.blexonBeschreibung;
			await this.updateMaterial(material);
		},
		goToArbeitspläne() {
			this.$router.push({ name: "workplans" });
		},
		goToTools() {
			this.$router.push({ name: "tools" });
		},
	},
};
</script>

<style>
table.v-table thead th {
	white-space: normal;
}
</style>
